import WaterHeroSection from "../components/WaterSection/WaterHeroSection";
import WaterNavigationMenu from "../components/WaterSection/WaterNavigationMenu";

const Water = () => {
  return (
    <div>
      <WaterHeroSection />
      <WaterNavigationMenu />
    </div>
  );
};

export default Water;
